<template lang="pug">
  Modal.permissions-modal(ref='modal' title="Permissions" :closeable="true")
    table.permissions-table
      tr.perms-head
        td
        td read
        td update
        td delete
        td admin
        td owner
      tr.perms-body(v-for="(p, i) in perms")
        td.subject-title
          i.fa(v-bind:class="{'fa-user': p.sid.user, 'fa-users': p.sid.group, 'fa-institution': p.sid.organization}")
          | &nbsp;{{p.sid.organization ? p.sid.organization.name : p.sid.group ? p.sid.group.name : p.sid.user.username}}
        td
          input(type="checkbox" :checked="p.isOwner || p.permissions.read" :disabled="p.isOwner" v-model="p.permissions.read")
        td
          input(type="checkbox" :checked="p.isOwner || p.permissions.update" :disabled="p.isOwner" v-model="p.permissions.update")
        td
          input(type="checkbox" :checked="p.isOwner || p.permissions.delete" :disabled="p.isOwner" v-model="p.permissions.delete")
        td
          input(type="checkbox" :checked="p.isOwner || p.permissions.admin" :disabled="p.isOwner" v-model="p.permissions.admin")
        td
          input(type='radio' v-model='p.isOwner' v-on:click='onChangeOwner(i)' value='true')
    .perms-footer
      v-select(:options="['user', 'organization', 'group']" v-model='selectedType' placeholder='Select type')
      v-select(:options='sids' label='label' v-model='selectedSubject' placeholder='Select subject')
      button.btn.btn-primary(@click.prevent='addSubject(selectedSubject)' :disabled="!canAddSubject") Add
    .red(v-if="errorMsg") {{ errorMsg }}
    div(slot="footer")
      button.btn.btn-default(@click="$refs.modal.cancel()") Cancel
      SspActionButton.create-button(type="button" text="Update" @onClick="save")
</template>

<script>
import vSelect from 'vue-select'
import miniToastr from 'mini-toastr'
import Modal from '@/components/common/Modal'
import Security from '@/service/apis/Security'
import Auth from '@/service/AuthService'

export default {
  data: () => ({
    object: {},
    perms: [],
    selectedType: null,
    selectedSubject: null,
    sids: [],
    errorMsg: null
  }),
  watch: {
    selectedType(type) {
      const context = Auth.getUserContext()
      this.selectedSubject = null
      switch (type) {
        case 'user': {
          Security.listUsersNonPriv({ max: 1000, offset: 0 })
            .then((resp) => {
              this.sids = resp.data.users.user.map((u) => {
                const s = {
                  label: u.username,
                  user: {
                    id: u.id,
                    username: u.username
                  }
                }
                return s
              })
            })
            .catch((e) => { this.$emit('error', e) })
          break;
        }
        case 'group': {
          Security.listGroups({ size: 1000 })
            .then((resp) => {
              this.sids = resp.data.content.map((g) => {
                const s = {
                  label: g.name,
                  group: {
                    id: g.id,
                    name: g.name
                  }
                }
                return s
              })
            })
            .catch((e) => { this.$emit('error', e) })
          break;
        }
        case 'organization': {
          this.sids = [{ label: context.organization.name, organization: { id: context.organization.id, name: context.organization.name } }]
          const [selectedSubject] = this.sids
          this.selectedSubject = selectedSubject
          break
        }
        default:
          this.sids = []
          break
      }
    }
  },
  computed: {
    canAddSubject() {
      if (!this.selectedSubject) {
        return false
      }
      const groupOrUser = this.selectedSubject.group ? 'group' : 'user'
      const lookupType = this.selectedSubject.organization ? 'organization' : groupOrUser

      const perm = this.perms[0]
      if (perm.sid[lookupType] && perm.sid[lookupType].id === this.selectedSubject[lookupType].id) {
        return false
      }
      return true
    }
  },
  methods: {
    save() {
      const perms = this.perms.map((p) => {
        let sid
        if (p.sid.organization) {
          sid = { organizationId: p.sid.organization.id }
        } else if (p.sid.group) {
          sid = { groupId: p.sid.group.id }
        } else {
          sid = { userId: p.sid.user.id }
        }
        const perm = {
          sid,
          permissions: p.permissions,
          isGranting: p.isGranting,
          isOwner: p.isOwner
        }
        return perm
      })
      return Security.savePermissions(this.object.id, this.object.type, { object: this.object, aces: { ace: perms } })
        .then(() => {
          this.$refs.modal.close()
          miniToastr.success('Permissions successfully saved')
        })
        .catch((e) => {
          this.errorMsg = e.response.data.message
        })
    },
    onChangeOwner(i) {
      this.perms.forEach((p, j) => {
        const permission = p
        if (j !== i) {
          permission.isOwner = false
        }
      })
    },
    addSubject(subj) {
      this.perms.push({
        sid: subj,
        permissions: {
          read: false,
          update: false,
          delete: false,
          admin: false
        },
        isOwner: false
      })
      this.selectedSubject = null
      this.selectedType = null
    },
    open(type, id) {
      this.errorMsg = null
      Security.getPermissions(id, type)
        .then((r) => {
          this.object = r.data.object
          this.perms = r.data.aces.ace
          this.perms[0].isOwner = true
          this.$refs.modal.open()
        })
    }
  },
  components: {
    Modal,
    vSelect
  }
}
</script>

<style lang="scss">
.permissions-modal {
  min-width: 400px;
  .permissions-table {
    margin-bottom: 15px;
    width: 100%;
  }
  .perms-footer {
    display: flex;
    .dropdown {
      margin-right: 15px;
    }
  }
  .perms-body:hover {
    background-color: whitesmoke;
  }
  .perms-body {
    .subject-title {
      text-align: left;
    }
    td {
      padding: 10px 0 10px 20px;

    }
  }
  .perms-head {
    text-transform: uppercase;
    font-weight: 400;
    font-size: 0.8em;
    td {
      padding: 10px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/ssp/Permissions.vue